"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Row;

var _react = _interopRequireDefault(require("react"));

var _toggleable = require("../toggleable");

var _base = require("../../base");

var _Base = require("./Base");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Row(_ref) {
  var row = _ref.row,
      index = _ref.index,
      deleteState = _ref.deleteState,
      prepareRow = _ref.prepareRow;
  prepareRow(row);

  var cellContent = function cellContent(cell) {
    return cell.column.noTranslate ? /*#__PURE__*/_react.default.createElement(_base.NoTranslate, null, cell.render('Cell')) : cell.render('Cell');
  };

  var cells = function cells() {
    return row.cells.map(function (cell) {
      return /*#__PURE__*/_react.default.createElement(_Base.Cell, _extends({}, cell.getCellProps(), {
        "data-title": cell.column.Header
      }), /*#__PURE__*/_react.default.createElement(_Base.CellInnerWrapper, null, cellContent(cell)));
    });
  };

  return /*#__PURE__*/_react.default.createElement(_Base.RowContainer, _extends({}, row.getRowProps({
    even: index % 2
  }), {
    showDeleteConfirmation: deleteState.isBeingDeleted(index),
    onDeleteCancel: deleteState.hideConfirmDelete,
    onDeleteConfirm: function onDeleteConfirm() {
      deleteState.onDeleteRow(row);
      deleteState.hideConfirmDelete();
    }
  }), cells(), /*#__PURE__*/_react.default.createElement(_toggleable.Toggleable, {
    show: deleteState.showDelete
  }, /*#__PURE__*/_react.default.createElement(_Base.DeleteCell, {
    onDelete: function onDelete() {
      return deleteState.showConfirmDelete(index);
    }
  })));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/containers/data_table/Row.js
// module id = 778
// module chunks = 0 15 16 17 18